import { render, staticRenderFns } from "./cabincharterLocation.vue?vue&type=template&id=9a567668&scoped=true"
import script from "./cabincharterLocation.vue?vue&type=script&lang=js"
export * from "./cabincharterLocation.vue?vue&type=script&lang=js"
import style0 from "./cabincharterLocation.vue?vue&type=style&index=0&id=9a567668&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a567668",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,VBreadcrumbs: require('/var/www/tubber-new/components/global/v/breadcrumbs.vue').default,VCarousel: require('/var/www/tubber-new/components/global/v/carousel.vue').default,VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default,RequestAction: require('/var/www/tubber-new/components/global/RequestAction.vue').default,VFullsizeGallery: require('/var/www/tubber-new/components/global/v/fullsize-gallery.vue').default})
